import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconGoals = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <circle cx="13" cy="13" r="8.25" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="13" cy="13" r="4.25" stroke="currentColor" strokeWidth="1.5" />
      <path d="M13 1V4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M4 13L1 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M13 25L13 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M22 13L25 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export default IconGoals
